import React, { useState, useEffect, useMemo } from 'react';
import Category from './Category/Category';
import { getAllCategories } from '../../containers/CategoriesContainer';
import { useLanguage } from '../../LanguageContext';
import { fetchTagVitrine } from '../../services/products-api';

const NavBar = () => {
    const [allCategories, setAllCategories] = useState([]);
    const [tags, setTags] = useState([]);
    const { translations, changeLanguage } = useLanguage();

    const propsNull = useMemo(() => ({
        id: null,
        descricao: translations.MenuPrincipal?.Categorias || 'Categorias'
    }), [translations.MenuPrincipal?.Categorias]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categories, tagResult] = await Promise.all([
                    getAllCategories(),
                    fetchTagVitrine()
                ]);

                setAllCategories(categories);

                if (tagResult.data.Codigo === 200 && tagResult.data.Data) {
                    const filteredTags = tagResult.data.Data.Dados
                        .filter(tag => tag.ExibirNoMenu === true);
                    setTags(filteredTags);
                }
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);

    const mainCategories = useMemo(() => 
        allCategories
            .filter(category => category.idClassificacaoNivelAnterior == null)
            .slice(0, 7)
    , [allCategories]);

    return (
        <div className="header_nav d-none d-sm-flex row m-0 align-items-center">
            <nav className="nav col-11 col-xl-10 p-0 position-relative">
                <ul className="list-unstyled m-0 col-sm-3 p-0">
                    <Category props={propsNull} />
                    {tags.length > 0 && (
                        <li className="nav-item col-lg-6 m-0 p-0">
                            <a 
                                role="button" 
                                href={`/destaque/${tags[0]?.Nome}`} 
                                className="nav-link px-0 pr-4 justify-content-center"
                            >
                                {tags[0]?.Descricao}
                            </a>
                        </li>
                    )}
                </ul>
                
                <ul className="list-unstyled mb-0 col-lg-8 p-0 display-block">
                    {mainCategories.map(category => (
                        <Category 
                            key={`cat-class-${category.idClassificacaoNivel}`} 
                            props={{
                                id: category.idClassificacaoNivel,
                                descricao: category.Descricao
                            }} 
                        />
                    ))}
                </ul>
            </nav>
        </div>
    );
};

export default NavBar;